<template>
  <span
    @click="
      $router.push({
        name: 'Upgrade',
        path: '/upgrade'
      })
    "
    class="premium"
    :class="{ inline: inline == true, block: inline != true }"
    v-if="$store.getters.getPackage == 'normal' || isCoachlabLock"
    v-tooltip.top="
      text === '' ? $t('Upgrade to {package} Plan', { package: $t('PREMIUM') }) : $t(text)
    "
  >
    <img src="/static/img/assets/_global/lock.svg" style="width: 20px" alt />
    <slot></slot>
  </span>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    inline: {
      default: false
    },
    text: {
      default: ''
    }
  },
  computed: {
    ...mapGetters(['selectedBot', 'isCoachlab']),

    isCoachlabLock() {
      return (
        this.isCoachlab &&
        ['conversation', 'broadcast', 'template', 'dashboard', 'training'].includes(
          this.$route.name
        )
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.premium {
  .simple-svg-wrapper {
    // background: white;
    display: inline-block;
  }
  // border-radius: 50%;
  // color: white;
  // padding: 0px 6px 4px 6px;
  // font-size: 9px;
  // height: 21px;
  // i{
  //     font-size: 9px;
  //     line-height: 9px;
  //     position: relative;
  //     top: 0;
  //     vertical-align: super;
  // }
  &.inline {
    // padding: 3px 6px 5px 6px;
    // top: -3px;
    position: relative;
    // vertical-align: middle;
    img {
      vertical-align: bottom;
    }
  }
  &.block {
    margin-top: -10px;
    margin-right: -6px;
    position: absolute;
    top: 0;
    right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/elements/PremiumLock.vue